import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import * as _ from 'lodash'

import Header from '../components/Header/Header'
import Favicon from '../components/Favicon/Favicon'
import AsideMenu from '../components/AsideMenu/AsideMenu'

import '../theme/defaults.scss'

type Props = {
  children: PropTypes.func
};
class Layout extends Component<Props> {
  state = { menuIsOpen: false };
  render() {
    const { children, data: { allMarkdownRemark: { edges } } } = this.props
    // const parts = _.uniqBy(edges, ({node:{frontmatter:{part,title,slug}}}) => part)

    return (
      <Fragment>
        <Favicon />
        <div id="outer-container" style={{ width: '100%', margin: '0' }}>
          <AsideMenu isOpen={this.state.menuIsOpen}
                     pageWrapId="page-wrap"
                     outerContainerId="outer-container"
                     right
                     menuItems={edges}
                     onStateChange={menuState => this.setState({ menuIsOpen: menuState.isOpen })}
                     hideMenu={() => this.setState({ menuIsOpen: false })} />
          <main id="page-wrap" style={{ width: '100%', maxWidth: '1440px', margin: '0 auto' }}>
            <Header onMenuButtonClick={() => this.setState({ menuIsOpen: true })} />
            {children()}
          </main>
        </div>
      </Fragment>
    )
  }
}
export default Layout
export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(filter: { frontmatter: { part: { ne: null }}}, sort: { fields: [frontmatter___date], order: ASC }) {
      edges {
        node {
          frontmatter {
            part
            title
            slug
            date
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/layouts/index.js